<template>
  <div class="item-right">
    <div class="recomend">
      <div class="reco-left">
        <i></i>
        <h3>好课推荐</h3>
      </div>
      <RouterLink
        target="_blank"
        :to="`/video?firstCate=${VideoReCommend[0]?.chID}&secondCate=${VideoReCommend[0]?.coID}&thirdCate=${VideoReCommend[0]?.clID}`"
        class="reco-right"
      >
        <p>更多</p>
        <el-icon><ArrowRight /></el-icon>
      </RouterLink>
    </div>
    <Transition name="fade">
      <div v-if="VideoReCommend.length">
        <template v-for="item in VideoReCommend" :key="item.index">
          <RouterLink
            v-show="item.id != $route.query.id"
            :to="`/video/videodetail?clID=${item.clID}&id=${item.id}`"
            target="_blank"
            class="reco-cate"
          >
            <img v-lazy="item.coverImg" alt="" />
            <i>{{ item.grade.prTeachWayName }}</i>
            <p class="grade" v-if="item.grade.grName.length <= 4">
              {{ item.grade.grName }}
            </p>
            <p class="grade1" v-if="item.grade.grName.length > 4">
              {{ item.grade.grName }}
            </p>
            <el-text line-clamp="2">
              {{ item.leName }}
            </el-text>
            <div class="reco-desc">
              <h4 tag="del">&yen;{{ item.grade.grPrice }}</h4>
              <h3>&yen;{{ item.grade.grPrice * 0.9 }}</h3>
            </div>
          </RouterLink>
        </template>
      </div>
      <VideoRecommendSkeleton v-else />
    </Transition>
  </div>
</template>

<script>
import VideoRecommendSkeleton from "./video-recommend-skeleton.vue";
export default {
  name: "VideoRecommend",
  components: {
    VideoRecommendSkeleton,
  },
  props: {
    VideoReCommend: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.item-right {
  width: 350px;
  //height: 1285px;
  border-radius: 8px;
  background: #fff;
  .recomend {
    display: flex;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px solid rgb(245, 245, 245);
    //background: rgb(245, 245, 245);
    .reco-left {
      display: flex;
      align-items: center;
      i {
        display: block;
        width: 3px;
        height: 20px;
        background: @shColor;
      }
      h3 {
        margin-left: 15px;
      }
    }
    .reco-right {
      display: flex;
      align-items: center;
      color: #999;
      .el-icon {
        margin-right: 8px;
      }
      &:hover {
        color: @shColor;
      }
    }
  }

  .reco-cate {
    display: block;
    position: relative;
    width: 350px;
    height: 309px;
    border: 1.5px solid #fff;

    //background: #c2bfbf;
    img {
      width: 350px;
      height: 224px;
    }
    .grade {
      position: absolute;
      font-weight: bold;
      font-size: 20px;
      top: 55.5%;
      left: 39%;
    }
    .grade1 {
      position: absolute;
      font-weight: bold;
      font-size: 20px;
      top: 55.5%;
      left: 34.37%;
    }
    i {
      display: inline-block;
      position: absolute;
      top: 0px;
      right: 0px;
      //width: 38px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      color: #fff;
      font-size: 12px;
      background: @shColor;
      border-radius: 5px;
      padding-left: 5px;
      padding-right: 5px;
    }
    span {
      margin: 5px 5px 5px 5px;
      &:hover {
        color: @shColor;
      }
    }
    .reco-desc {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      h3 {
        //width: 80px;
        margin-left: 10px;
        color: #fd7502;
        margin-right: 25px;
      }
      h4 {
        margin-left: 25px;
        text-decoration: line-through;
      }
    }
  }
}
</style>
